import { useEffect, useState } from "react";
import { api, eur, formatDate } from "@/lib/api";

export default function OrdersManager() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/admin/orders").then((r) => setOrders(r.data)).catch(() => {});
  }, []);

  return (
    <section data-testid="orders-manager">
      <h2 className="font-serif text-3xl text-forest">Ordini completati</h2>
      <p className="mt-2 text-sm text-sage">Pagamenti Stripe andati a buon fine.</p>
      <div className="mt-8 overflow-x-auto rounded-sm border border-line bg-bone">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-line font-accent text-[10px] uppercase tracking-[0.2em] text-sage">
              <th className="px-5 py-4">Data</th>
              <th className="px-5 py-4">Prodotti</th>
              <th className="hidden px-5 py-4 md:table-cell">Cliente</th>
              <th className="px-5 py-4 text-right">Totale</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-line/60 last:border-0" data-testid={`order-row-${o.id}`}>
                <td className="px-5 py-4 text-sage">{formatDate(o.created_at)}</td>
                <td className="px-5 py-4 text-forest">
                  {(o.items || []).map((i) => `${i.name} ×${i.quantity}`).join(", ")}
                </td>
                <td className="hidden px-5 py-4 text-sage md:table-cell">{o.customer_email || "—"}</td>
                <td className="px-5 py-4 text-right font-medium text-forest">{eur((o.amount || 0) / 100)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {orders.length === 0 && <p className="px-5 py-10 text-center text-sage" data-testid="orders-empty">Nessun ordine ancora.</p>}
      </div>
    </section>
  );
}
